export * from './factory'

// TODO: remove it
export function apiClient<TResult = unknown>() {}
